import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {Moment} from 'moment-timezone';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {isDefined} from '../../../../commons/commons';
import {takeUntil} from 'rxjs/operators';
import {limitDecimals} from '../../../../shared/ec-economics';

@Component({
    selector: 'app-membership-fee',
    templateUrl: './membership-fee.component.html',
    styleUrls: ['./membership-fee.component.scss']
})
export class MembershipFeeComponent implements OnInit, OnDestroy {
    private destroyed = new Subject<void>();

    @Input() date: Moment;
    @Input() currentMembershipFee: number;
    @Output() membershipFeeEmitter: EventEmitter<number> = new EventEmitter<number>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    year: number;
    form: FormGroup;

    constructor(private readonly fb: FormBuilder) {
        this.form = this.fb.group(
            {membershipFeeControl: new FormControl(null, [Validators.required])},
            {validators: [validate]}
        );
    }

    ngOnInit() {
        if (isDefined(this.currentMembershipFee)) {
            this.form.controls.membershipFeeControl.setValue(this.currentMembershipFee);
        }
        this.year = this.date.year();
        this.form.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(value => this.membershipFeeEmitter.emit(value.membershipFeeControl));
        this.form.statusChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.valid.emit(this.form.valid));
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

    limitDecimals() {
        limitDecimals(this.form, 'membershipFeeControl');
    }
}

function validate(ctrl: AbstractControl): ValidationErrors | null {
    const errs: ValidationErrors = {};
    const ctrls: { [ctrl: string]: AbstractControl } = (ctrl as FormGroup).controls;
    if ((ctrls.membershipFeeControl != null && ctrls.membershipFeeControl.value < 0) ||
        (ctrls.membershipFeeControl != null && ctrls.membershipFeeControl.value > 1000)) {
        errs.out_of_range_values = true;
    }
    return Object.values(errs).every(err => !err) ? null : errs;
}
